<template lang="pug">
  .lesson-block__content
    p.lesson-block__title.main-block__title(v-if="contentLocal.taskBlock")
      | {{contentLocal.taskBlock.systemName}}

    Input.lesson-block__edit(
      v-if="contentLocal.taskBlock"
      v-model="contentLocal.taskBlock.systemName"
      title="Название задания"
    )

    template(v-for="item in contentLocal.questionArray")
      MarkdownText.lesson-block__edit.lesson-block__markdown(
        v-model="item.question.question"
        title="Вопрос"
      )

      .lesson-block__row
        Select.lesson-block__select.-grow-(
          v-model="item.question.typeOfTask"
          title="Балл за решение"
          :selectData="ballData"
        )

        template(v-if="item.question.typeOfTask === 1")
          Input.lesson-block__edit.-no-grow-(
            :key="3"
            v-model="item.question.pointsBeforeDdl"
            type="number"
            title="До DDL"
          )

          Input.lesson-block__edit.-no-grow-(
            :key="4"
            v-model="item.question.pointsAfterDdl"
            type="number"
            title="После DDL"
          )

        template(v-if="item.question.typeOfTask === 2")
          Input.lesson-block__edit.-no-grow-(
            :key="1"
            v-model="item.question.minPoints"
            type="number"
            title="От"
          )

          Input.lesson-block__edit.-no-grow-(
            :key="2"
            v-model="item.question.maxPoints"
            type="number"
            title="До"
          )

      .lesson-block__row(v-if="item.question.typeOfTask === 1 && item.question.isAutoCheck")
        TextArea.lesson-block__edit(
          :key="10"
          v-model="item.question.textBeforeDdl"
          :maxlength="500"
          title="Ответ до DDL"
        )

        TextArea.lesson-block__edit(
          :key="11"
          v-model="item.question.textAfterDdl"
          :maxlength="500"
          title="Ответ после DDL"
        )

      .lesson-block__row
        InputDate.lesson-block__edit(
          v-if="contentLocal.taskBlock"
          v-model="contentLocal.taskBlock.ddl"
          showTimePanel
          ddl
          title="Дата дедлайна"
        )

        Select.lesson-block__select.-grow-(
          v-model="item.question.isFileAnswerAllow"
          title="Ученик может прикреплять файлы"
          :selectData="fileAllowData"
        )

      SwitchBlock(
        v-if="item.question.typeOfTask == 1"
        text="Автопроверка"
        v-model="item.question.isAutoCheck"
      )
      SwitchBlock(
        text="Ручная проверка после DDL"
        v-model="item.question.isReviewAfterDdl"
      )
      SwitchBlock(
        v-if="item.question.typeOfTask == 1"
        text="Запретить ссылки в ответе"
        v-model="item.question.isLinkForbidden"
      )

    .lesson-block__buttons
      Button.-xs-(@click="emitSave" :isLoading="isLoading") Сохранить
      ButtonCancel.-xs-.hover__link(@click="cancel") Отмена

</template>

<script>
import _ from 'lodash';
import MarkdownText from '@/components/Form/MarkdownText';

export default {
  components: { MarkdownText },
  props: ['propContentLocal', 'saveBlock', 'isLoading'],
  data: () => ({
    contentLocal: {
      question: {
        typeOfTask: 1
      }
    },
    taskCheckData: [
      {
        text: 'Задание с автопроверкой',
        value: true
      },
      {
        text: 'Задание с ручной проверкой ',
        value: false
      }
    ],
    fileAllowData: [
      {
        text: 'Да',
        value: true
      },
      {
        text: 'Нет',
        value: false
      }
    ]
  }),
  computed: {
    ballData() {
      let arr = [
        {
          text: 'Фиксированный балл',
          value: 1
        },
        {
          text: 'Выбор балла',
          value: 2
        }
      ];

      if (this.contentLocal.taskBlock && !this.contentLocal.taskBlock.ddl) {
        arr = [
          {
            text: 'Выбор балла',
            value: 2
          }
        ];
      }

      return arr;
    }
  },
  watch: {
    contentLocal: {
      deep: true,
      handler(curr, prev) {
        if (!prev.questionArray) {
          return;
        }

        curr.questionArray.forEach(q => {
          if (!curr.taskBlock.ddl) {
            q.question.typeOfTask = 2;
          }

          if (q.question.typeOfTask === 2) {
            q.question.isAutoCheck = false;
          }
        });
      }
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.propContentLocal);

      this.contentLocal.questionArray.forEach(q => {
        if (q.question.typeOfTask === 2) {
          q.question.isAutoCheck = false;
        }
      });
    },
    getNumberIcon(key) {
      switch (key) {
        case 'money':
          return 'purse';
        case 'deals':
          return 'deal';
        case 'analytics':
          return 'analytics';
        case 'marketing':
          return 'marketing';
        case 'sales':
          return 'deal';
        case 'team':
          return 'user-group';
        default:
          return '';
      }
    },
    getNumberText(key) {
      switch (key) {
        case 'money':
          return 'Деньги';
        case 'deals':
          return 'Сделки';
        case 'analytics':
          return 'Аналитика';
        case 'marketing':
          return 'Маркетинг';
        case 'sales':
          return 'Продажи';
        case 'team':
          return 'Команда';
        default:
          return '';
      }
    },
    emitSave() {
      this.$emit('update:propContentLocal', this.contentLocal);
      this.$emit('saveBlock');
    },
    cancel() {
      this.$emit('cancel');
      this.setData();
    }
  }
};
</script>
